var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgInfoIcon = function SvgInfoIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58166 0 0 3.58178 0 8C0 12.4185 3.58166 16 8 16C12.4183 16 16 12.4185 16 8C16 3.58178 12.4183 0 8 0ZM8 4C8.55231 4 9 4.44775 9 5C9 5.5525 8.55231 6 8 6C7.44769 6 7 5.5525 7 5C7 4.44775 7.44769 4 8 4ZM9.5 12H6.5C6.22388 12 6 11.7764 6 11.5C6 11.2239 6.22388 11 6.5 11H7V8H6.5C6.22388 8 6 7.77637 6 7.5C6 7.22388 6.22388 7 6.5 7H8.5C8.77612 7 9 7.22388 9 7.5V11H9.5C9.77612 11 10 11.2239 10 11.5C10 11.7764 9.77612 12 9.5 12Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInfoIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "info-icon.4ec382555e0b79fdbcf87e7ab304fe57.svg";